function toMillis(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.toDate === 'function') return value.toDate().getTime();
  if (value instanceof Date) return value.getTime();

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
}

export function getLatestProgram(programs = []) {
  if (!Array.isArray(programs) || !programs.length) return null;

  return programs
    .filter(Boolean)
    .slice()
    .sort((a, b) => toMillis(a?.dataCreazione) - toMillis(b?.dataCreazione))
    .pop() || null;
}

export function buildLatestProgramMirror(programs = []) {
  const latestProgram = getLatestProgram(programs);

  return {
    latestProgramId: latestProgram?.id || null,
    latestProgramDataCreazione: latestProgram?.dataCreazione || null,
    latestProgramNoteselect: latestProgram?.noteselect || null,
  };
}
